import React, { useContext, useState } from "react";
import { Aside, EditButton, ListActionButtonProps } from "sprint-common-web";

import { EncodeSpecificationsDataContext } from "../../../../../common/data/lookup-data-providers/EncodeSpecificationsDataProvider";
import { SystemPlatformDetailsSpecificationItem } from "../../SystemPlatformDetailsItem";
import { EditSpecificationForm } from "./EditSpecificationForm";

export const EditSpecificationButton: React.FC<ListActionButtonProps<SystemPlatformDetailsSpecificationItem>> = (
    props: ListActionButtonProps<SystemPlatformDetailsSpecificationItem>
) => {
    const { isLoading: isEncodeSpecificationsLoading } = useContext(EncodeSpecificationsDataContext);

    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const openSidebar = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.currentTarget.blur();
        setIsSidebarOpen(true);
    };

    return (
        <>
            <EditButton onClick={openSidebar} testId="edit-specification-button" iconName="EditSolid12" />
            <Aside
                isOpen={isSidebarOpen}
                type="form"
                headerText="Edit"
                onDismiss={closeSidebar}
                isLoading={isEncodeSpecificationsLoading}
            >
                <EditSpecificationForm
                    onCancel={closeSidebar}
                    onSubmit={closeSidebar}
                    encodeSpecificationContentType={Number(props.itemId)}
                />
            </Aside>
        </>
    );
};
